<script>
import _ from 'lodash'
import moment from 'moment'
import TempFollowupService from '@/request/template/Followup'
import TempFollowupFavoriteService from '@/request/template/FollowupFavorites'
export default {
  name: 'TempFollowupListSelection',
  components: {},
  props: {},
  data () {
    return {
      pagination: {
        sort: null,
        order: null,
        size: 10,
        total: 0,
        current: 1,
        layout: 'total, sizes, prev, pager, next, jumper',
        sizes: [10, 20, 30]
      },
      options: {
        ids: null,
        oids: null,
        level: null,
        match: null,
        notpub: null,
        recently: null
      },
      currentTab: 1,
      listLoading: false,
      list: [],
      editFollowup: {},
      visibleEditFollowup: false
    }
  },
  computed: {},
  created () {
    this.listTemp()
  },
  watch: {
    currentTab (newVal, oldVal) {
      if (newVal === oldVal) {
        return
      }
      this.pagination.current = 1
      this.listTemp()
    },
    'options.match' () {
      this.pagination.current = 1
      this.listTemp()
    }
  },
  methods: {
    listTemp () {
      this.listLoading = true
      let fn = TempFollowupService.find
      this.options.recently = null
      this.options.level = null
      if (this.currentTab === 1) {
        fn = TempFollowupService.find
        this.options.recently = 1
      } else if (this.currentTab === 2) {
        fn = TempFollowupFavoriteService.find
      } else if (this.currentTab === 3) {
        fn = TempFollowupService.find
        this.options.level = -1
      } else {
        fn = TempFollowupService.find
      }
      fn(this.pagination, this.options).then(res => {
        res = res.result
        this.pagination.total = res['totalElements'] || 0
        this.list = _.clone(res['content'] || [])
      }).finally(() => {
        this.listLoading = false
      })
    },
    handleSizeChange (val) {
      this.pagination.size = val
      this.listTemp()
    },
    handleCurrentChange (val) {
      this.pagination.current = val
      this.listTemp()
    },
    formatterCreateTime (row) {
      if (!row || !row.createTime) {
        return ''
      }
      return moment(row.createTime).format('YYYY-MM-DD HH:mm:ss')
    },
    showPlan (row) {
      if (!row) {
        return
      }
      if (!this.$refs['followupList']) {
        return
      }
      this.$refs['followupList'].toggleRowExpansion(row)
    },
    select (item) {
      this.$emit('selected', this.currentTab === 2 ? item.fid : item.id)
    },
    cancle () {
      this.$emit('cancle')
    },
    favorite (item) {
      if (!item || !item.id) {
        return
      }
      TempFollowupFavoriteService.save({
        fid: item.id
      }).then(() => {
        if (this.currentTab !== 2) {
          this.currentTab = 2
        } else {
          this.listTemp()
        }
      })
    },
    deleteFavorite (item) {
      if (!item || !item.fid) {
        return
      }
      this.$confirm('确认取消收藏模板[' + item.name + ']吗?', '提示', {type: 'warning'}).then(() => {
        TempFollowupFavoriteService.delete({
          fid: item.fid
        }).then(() => {
          if (this.currentTab !== 2) {
            this.currentTab = 2
          } else {
            this.listTemp()
          }
        })
      }).catch(() => {
        this.$message({
          message: '取消操作!',
          type: 'info'
        })
      })
    },
    handleCansleEditFollowup () {
      this.editFollowup = {}
    },
    editTemp (item) {
      this.editFollowup = _.cloneDeep(item || {}),
      this.visibleEditFollowup = true
    },
    saveTempFollowupDone () {
      this.$message({
        message: '保存随访模板完成',
        type: 'success'
      })
      this.visibleEditFollowup = false
      this.currentTab = 4
      this.listTemp()
    },
    deleteTempFollowupDone () {
      this.$message({
        message: '删除随访模板完成',
        type: 'success'
      })
      this.visibleEditFollowup = false
      this.listTemp()
    },
    saveFollowup () {
      if (this.$refs['tempFollowupEditRef'].save) {
        this.$refs['tempFollowupEditRef'].save()
      }
    }
  }
}
</script>

<template>
  <div class="list-wrap">
    <el-form inline class="demo-form-inline" size="mini">
      <el-form-item>
        <el-button type="default" @click="cancle()">返 回</el-button>
      </el-form-item>
      <el-form-item>
        <el-radio-group v-model="currentTab">
          <el-radio-button :label="parseInt(1)">最近使用</el-radio-button>
          <el-radio-button :label="parseInt(2)">我的收藏</el-radio-button>
          <!-- <el-radio-button :label="parseInt(3)">我的模板</el-radio-button> -->
          <el-radio-button :label="parseInt(4)">全 部</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="editTemp()">创建模板</el-button>
      </el-form-item>
      <el-form-item v-if="currentTab >= 3">
        <el-input v-model="options.match" placeholder="输入关键字查找"></el-input>
      </el-form-item>
    </el-form>
    <el-table
       ref="followupList"
      :data="list"
      height="420"
      v-loading="listLoading"
      border
      stripe>
      <el-table-column type="expand">
        <template slot-scope="props">
          <temp-followup-plan-list ref="planList" :fid="currentTab === 2 ? props.row.fid : props.row.id"></temp-followup-plan-list>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="名称"></el-table-column>
      <!-- <el-table-column prop="createTime" :formatter="formatterCreateTime" label="创建时间" width="160"></el-table-column>
      <el-table-column prop="level" label="公开级别">
        <template slot-scope="scope">
          <span v-if="scope.row.level === -1">个人</span>
          <span v-if="scope.row.level === 0">公开</span>
          <span v-if="scope.row.level === 1">组织</span>
        </template>
      </el-table-column> -->
      <el-table-column label="操作" width="220">
        <template slot-scope="scope">
          <el-button size="small" type="text" @click="select(scope.row)">选择</el-button>
          <el-button size="small" type="text" @click="favorite(scope.row)" v-if="currentTab !== 2">收藏</el-button>
          <el-button size="small" type="text" @click="deleteFavorite(scope.row)" v-if="currentTab === 2">取消收藏</el-button>
          <el-button size="small" type="text" @click="showPlan(scope.row)">查看计划</el-button>
          <el-button size="small" type="text" @click="editTemp(scope.row)" v-if="$store.getters.user && $store.getters.user.id === scope.row.creatorId">修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.current" :page-sizes="pagination.sizes" :page-size="pagination.size" :layout="pagination.layout" :total="pagination.total"></el-pagination>
    <!-- 编辑随访 -->
    <el-dialog title="编辑随访" :visible.sync="visibleEditFollowup" @close="handleCansleEditFollowup" append-to-body width="80%" top="60px" fullscreen>
      <!-- <el-form inline class="demo-form-inline" size="mini">
        <el-form-item>
          <el-button type="primary" @click="saveFollowup()">保 存</el-button>
        </el-form-item>
      </el-form> -->
      <temp-followup-edit ref="tempFollowupEditRef" :data="editFollowup" @save-done="saveTempFollowupDone" @delete-done="deleteTempFollowupDone" @cancle="visibleEditFollowup = false"></temp-followup-edit>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button @click="visibleEditFollowup = false">取 消</el-button>
        <el-button type="primary" @click="$refs['followupEditRef'].save()">确定</el-button>
      </div> -->
    </el-dialog>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
